/**
 * EmailJS public config — env only (TA-027). Never hardcode service/template/keys.
 */
import { publicEnv } from "@/config/env";

export function getEmailJsConfig() {
  return {
    serviceId: publicEnv("NEXT_PUBLIC_EMAILJS_SERVICE_ID"),
    templateId: publicEnv("NEXT_PUBLIC_EMAILJS_TEMPLATE_ID"),
    publicKey: publicEnv("NEXT_PUBLIC_EMAILJS_PUBLIC_KEY"),
  };
}

export function isEmailJsConfigured() {
  const { serviceId, templateId, publicKey } = getEmailJsConfig();
  return Boolean(serviceId && templateId && publicKey);
}

/** @returns {{ serviceId: string, templateId: string, publicKey: string }} */
export function requireEmailJsConfig() {
  const cfg = getEmailJsConfig();
  if (!cfg.serviceId || !cfg.templateId || !cfg.publicKey) {
    throw new Error(
      "Email is not configured. Set NEXT_PUBLIC_EMAILJS_SERVICE_ID, NEXT_PUBLIC_EMAILJS_TEMPLATE_ID, and NEXT_PUBLIC_EMAILJS_PUBLIC_KEY.",
    );
  }
  return cfg;
}
